export default __webpack_public_path__ + "assets/favicons/apple-touch-icon.png";